import React from "react";
import Home from "./pages/Home";
import {BrowserRouter , Routes , Route} from "react-router-dom"
import About from "./pages/About";
import Epuja from "./pages/Epuja";
import PujaServices from "./pages/PujaServices";
import Pandit from "./pages/Pandit";
import ContactUs from "./pages/ContactUs";
import RegisterForm from "./pages/RegisterForm";
import LoginForm from "./pages/LoginForm";
import Profile from "./pages/Profile";
import BookingAppointmentForm from "./pages/BookingAppointmentForm";
import CookiesPolicy from "./pages/CookiesPolicy";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import RefundPolicy from "./pages/RefundPolicy";

import Viewall from "./pages/Viewall";
import ForgotPassword from "./pages/ForgotPassword";




function App() {
  return (
    <div>
    <BrowserRouter>
    <Routes>
     <Route path="/" element={<Home />} />
<Route path="/about" element={<About />} />
<Route path="/epuja" element={<Epuja />} />
<Route path="/puja-service" element={<PujaServices />} />
<Route path="/pandit" element={<Pandit />} />
<Route path="/contact" element={<ContactUs />} />
<Route path="/register" element={<RegisterForm />} />
<Route path="/login" element={<LoginForm />} />
<Route path="/profile" element={<Profile />} />
<Route path="/viewall/:id" element={<Viewall />} />
<Route  path="/booking-appointment"  element={<BookingAppointmentForm />}/>

<Route  path="/forgot-password"  element={<ForgotPassword />}/>

<Route  path="/cookies-policy"  element={<CookiesPolicy />}/>
<Route  path="/privacy-policy"  element={<PrivacyPolicy />}/>
<Route  path="/terms-conditions"  element={<TermsConditions />}/>
<Route  path="/refund-policy"  element={<RefundPolicy />}/>

    </Routes>
    </BrowserRouter>
    
    </div>
  );
}

export default App;
